import React from 'react';
import { ButtonPrimary } from '../../../components/auth/ButtonPrimary';
import { ButtonGoogle } from '../../../components/auth/ButtonGoogle';
import { InputEmail } from '../../../components/auth/InputEmail';
import { SOLO_ACTIVA } from '../../../config/producto';

interface EmailStepProps {
    email: string;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onSubmit: (e: React.FormEvent) => Promise<void>;
    isLoading: boolean;
    error: string | null;
}

export const EmailStep: React.FC<EmailStepProps> = ({
    email,
    onChange,
    onSubmit,
    isLoading,
    error
}) => {
    return (
        <form onSubmit={onSubmit} className="flex flex-col gap-6 w-full max-w-sm animate-fade-in">
            <div className="space-y-2 text-center">
                <h1 className="text-3xl font-bold tracking-tight text-text-primary">
                    Bienvenido
                </h1>
                <p className="text-text-secondary">
                    Ingresá tu email para acceder a tu cuenta
                </p>
            </div>

            <div className="space-y-4">
                <div className="space-y-2">
                    {/* H08: label visible + autocomplete para accesibilidad y gestores de contraseñas */}
                    <label
                        htmlFor="email-input"
                        className="block text-sm font-medium text-text-secondary text-left"
                    >
                        Correo electrónico
                    </label>
                    <InputEmail
                        id="email-input"
                        name="email"
                        autoComplete="email"
                        value={email}
                        onChange={onChange}
                        placeholder="nombre@empresa.com"
                        error={!!error}
                        disabled={isLoading}
                        autoFocus
                    />
                    {error && (
                        <p className="text-sm text-error font-medium animate-shake">
                            {error}
                        </p>
                    )}
                </div>

                <ButtonPrimary
                    type="submit"
                    isLoading={isLoading}
                    showArrow
                >
                    Continuar
                </ButtonPrimary>
            </div>

            {/* Google sólo en el producto completo: con SOLO_ACTIVA se entra con el mail de la lista de
                Accesos, y /auth/google ni se monta sin GOOGLE_CLIENT_ID. */}
            {!SOLO_ACTIVA && (
                <>
                    <div className="relative">
                        <div className="absolute inset-0 flex items-center">
                            <span className="w-full border-t border-input-border" />
                        </div>
                        <div className="relative flex justify-center text-xs uppercase">
                            <span className="bg-white px-2 text-text-muted">
                                O ingresá con
                            </span>
                        </div>
                    </div>

                    <ButtonGoogle
                        onClick={() => {
                            // Usa VITE_API_URL para no hardcodear el host (dev vs prod)
                            const base = import.meta.env.VITE_API_URL || "/api/v1";
                            window.location.href = `${base}/auth/google`;
                        }}
                    />
                </>
            )}
        </form>
    );
};
